export enum EventType {
  FilterSection = 'filter_section',
  FilterAttribute = 'filter_attribute',
}
